import { render, staticRenderFns } from "./CompanyHomeVertical.vue?vue&type=template&id=964db94c&scoped=true&"
import script from "./CompanyHomeVertical.vue?vue&type=script&lang=js&"
export * from "./CompanyHomeVertical.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHomeVertical.vue?vue&type=style&index=0&id=964db94c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964db94c",
  null
  
)

export default component.exports